<template>
  <section-carousel :carouselId="carouselId" :bigBannerImages="bigBannerImages" :buttonText="buttonText"></section-carousel>
</template>
<script>
import SectionCarousel from '../../components/Shared/Carousel';
import Banner1 from '../../assets/image/about/banner1.jpg';
import Banner2 from '../../assets/image/about/banner1.jpg';
import Banner3 from '../../assets/image/about/banner1.jpg';
export default {
  data(){
    return{
      carouselId: 'about-carousel',
      buttonText:"WATCH NOW",
      bigBannerImages:[
        Banner1,
        Banner2,
        Banner3
      ]
    }
  },
  components:{
    'section-carousel': SectionCarousel
  }
}
</script>